import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "./TypeWithDriverDetailPage.css";
import { useState } from "react";
const TypeWithDriverDetailPage = () => {
  const [bookingType, setBookingType] = useState("self");
  const [showPolicy, setShowPolicy] = useState(false);

  const [paymentType, setPaymentType] = useState("full"); // default full
  const [showAllFeatures, setShowAllFeatures] = useState(false);
    const [dropLocation, setDropLocation] = useState("");
    const [pickupDateTime, setPickupDateTime] = useState("");
  const [pickupLocation, setPickupLocation] = useState("");
    const [dropDateTime, setDropDateTime] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const basicFeatures = [
    "Spare Tyre",
    "2 Front Airbags",
    "Child Seat",
    "ABS (Anti-lock)",
  ];

  const extraFeatures = [
    "Reverse Camera",
    "Toolkit",
    "Bluetooth",
    "USB Charging",
  ];

  const [userDetails, setUserDetails] = useState({
    name: "",
    phone: "",
    email: "",
    passengerName: "",
    passengerPhone: "",
    agreed: true,
  });
  const [files, setFiles] = useState({
    userId: null,
    passengerId: null,
  });
  const handleFileChange = (field, file) => {
    setFiles((prev) => ({
      ...prev,
      [field]: file,
    }));
  };
  const [errors, setErrors] = useState({});
  const handleInputChange = (field, value) => {
    setUserDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  useEffect(() => {
    const fromPayment = sessionStorage.getItem("fromPayment");

    if (fromPayment === "true") {
      const saved = sessionStorage.getItem("rentalPageData");

      if (saved) {
        const parsed = JSON.parse(saved);

        setUserDetails(parsed.userDetails || {});
        setDropDateTime(parsed.dropDateTime || "");
        setBookingType(parsed.bookingType || "self");
      }

      // ✅ Clear flag after restoring
      sessionStorage.removeItem("fromPayment");
    } else {
      // ❌ Fresh visit → clear old data
      sessionStorage.removeItem("rentalPageData");
    }
  }, []);
  const validateForm = () => {
    let newErrors = {};

    // Name
    if (!userDetails.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(userDetails.name)) {
      newErrors.name = "Name should contain only letters";
    }
    // Email validation
    if (!userDetails.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(userDetails.email)
    ) {
      newErrors.email = "Enter a valid email address";
    }
    if (!files.userId) {
      newErrors.userId = "Government ID is required";
    } else {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (!allowedTypes.includes(files.userId.type)) {
        newErrors.userId = "Only JPG, PNG or PDF allowed";
      }

      if (files.userId.size > 2 * 1024 * 1024) {
        newErrors.userId = "File size must be under 2MB";
      }
    }
    // Phone (basic validation)
    if (!userDetails.phone.trim()) {
      newErrors.phone = "Phone is required";
    } else if (!/^[0-9]{10}$/.test(userDetails.phone)) {
      newErrors.phone = "Enter valid 10-digit number";
    }

    // Passenger (if booking for someone else)
    if (bookingType === "other") {
      if (!userDetails.passengerName.trim()) {
        newErrors.passengerName = "Passenger name required";
      } else if (!/^[A-Za-z\s]+$/.test(userDetails.passengerName)) {
        newErrors.passengerName = "Passenger name should contain only letters";
      }

      if (!userDetails.passengerPhone.trim()) {
        newErrors.passengerPhone = "Passenger phone required";
      }
      if (!files.passengerId) {
        newErrors.passengerId = "Passenger ID required";
      }
    }
if (!pickupLocation.trim())
  newErrors.pickupLocation = "Pickup location required";

if (!dropLocation.trim()) newErrors.dropLocation = "Drop location required";

if (!pickupDateTime) newErrors.pickupDateTime = "Pickup date required";

if (!dropDateTime) newErrors.dropDateTime = "Drop date required";
   

    // Terms checkbox
    if (!userDetails.agreed) {
      newErrors.agreed = "You must accept terms";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePayment = () => {
    if (!validateForm()) return;

    const finalData = {
      ...data,
      userDetails,
      dropDateTime,
      bookingType,
      total,
      paymentType,
      payableAmount,
    };

    sessionStorage.setItem(
      "rentalPageData",
      JSON.stringify({
        userDetails,
        dropDateTime,
        bookingType,
        paymentType,
      }),
    );

    navigate("/payment-page", {
      state: finalData,
    });
  };
let data = location.state;

if (!data) {
  const saved = sessionStorage.getItem("selectedCar");
  data = saved ? JSON.parse(saved) : null;
}

if (!data) return <h2>No Data Found</h2>;
  const carData = data?.carData || {};
  const pickup = data?.pickup;

const baseFare = data?.totalPrice || carData.price;
  const discount = 200;
  const gst = Math.round(baseFare * 0.18);
  const security = 4000;

  const total = baseFare - discount + gst + security;
  const payableAmount = paymentType === "half" ? Math.round(total / 2) : total;
  return (
    <div className="rental-details-container">
      <p className="back-link" onClick={() => navigate(-1)}>
        ← Back to Results
      </p>
      <div className="top-section">
        <div className="upper-section">
          {/* LEFT SIDE */}

          <div className="image-grid">
            {/* MAIN IMAGE */}
            <img src={carData?.image} className="main-img" alt="car" />

            {/* SIDE IMAGES (same image repeated as your UI) */}
            <div className="side-images">
              <img src={carData?.image} alt="" />
              <img src={carData?.image} alt="" />
              <img src={carData?.image} alt="" />
              <img src={carData?.image} alt="" />
            </div>
          </div>
        </div>
        <div className="lower-section">
          <div className="left-section">
            <h1
              style={{
                color: "black",
                fontSize: "30px",
                fontStyle: "italic",
                marginRight: "300px",
                marginTop: "20px",
              }}
            >
              {carData?.name}
            </h1>

            <p className="car-info">
              2024 • Manual • {carData.fuel} • 7 Seats • ★ 4.9
            </p>

            <div className="hosted">Hosted by: Anmol (ZikRme Verified)</div>
          </div>
        </div>
      </div>
      <div className="bottom-section">
        <div className="bottom left-section">
          <div className="card">
            <div>
              {" "}
              <label>Enter your detailed pickup location</label>
              <input
                type="text"
                value={pickupLocation}
                onChange={(e) => setPickupLocation(e.target.value)}
                placeholder="Enter Exact Pickup Location"
              />
            </div>
            <div>
              <label>Enter your detailed drop location</label>
              <input
                type="text"
                value={dropLocation}
                onChange={(e) => setDropLocation(e.target.value)}
                placeholder="Enter Exact Drop Location"
              />
            </div>
            <div className="date-row">
              <div className="form-group">
                <p>PICKUP DATE/TIME</p>
                <input
                  type="datetime-local"
                  value={pickupDateTime}
                  onChange={(e) => setPickupDateTime(e.target.value)}
                />
              </div>

              <div className="form-group">
                <p>DROP DATE & TIME</p>
                <input
                  type="datetime-local"
                  value={dropDateTime}
                  onChange={(e) => setDropDateTime(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="features-section">
            <h2>Car Features</h2>

            <div
              className={`features-grid ${showAllFeatures ? "three-col" : "two-col"}`}
            >
              {basicFeatures.map((item, index) => (
                <div key={index} className="feature">
                  ✅ {item}
                </div>
              ))}

              {showAllFeatures &&
                extraFeatures.map((item, index) => (
                  <div key={index} className="feature">
                    ✅ {item}
                  </div>
                ))}
            </div>

            <p
              className="view-more"
              onClick={() => setShowAllFeatures(!showAllFeatures)}
            >
              {showAllFeatures ? "Show Less" : "View More Features"}
            </p>
          </div>

          <div className="policy-section">
            <h2>Rental Policy</h2>

            <div className="policy-row">
              <span className="inclusion">● Inclusion: Fuel (100km)</span>
              <span className="exclusion">● Exclusion: Toll/Parking</span>
            </div>

            <button
              className="rental-policy-btn"
              onClick={() => setShowPolicy(true)}
            >
              Read Full Policy
            </button>
          </div>
        </div>
        <div className="bottom-right-section">
          <h1 className="title">Complete Your Booking</h1>

          {/* YOUR DETAILS (ALWAYS VISIBLE) */}
          <div className="input-row">
            <input
              type="text"
              placeholder="Your Full Name"
              value={userDetails.name}
              onChange={(e) => {
                const value = e.target.value;

                // allow only letters + space
                if (/^[A-Za-z\s]*$/.test(value)) {
                  handleInputChange("name", value);
                }
              }}
            />
            {errors.name && <p className="error">{errors.name}</p>}
            <input
              type="text"
              placeholder="Your Phone Number"
              value={userDetails.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
            />
            {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
          <div className="input-row">
            <input
              type="email"
              placeholder="Your Email"
              value={userDetails.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </div>
          <div className="file-section">
            <p>Your Govt ID (Both Sides)</p>
            <input
              type="file"
              onChange={(e) => handleFileChange("userId", e.target.files[0])}
            />
            {errors.userId && <p className="error">{errors.userId}</p>}
          </div>

          {/* TRAVEL DROPDOWN */}
          <div className="travel-box">
            <select
              value={bookingType}
              onChange={(e) => setBookingType(e.target.value)}
            >
              <option value="self">I am travelling myself</option>
              <option value="other">I am booking for someone</option>
            </select>
          </div>

          {/* PASSENGER DETAILS (SHOW ONLY IF "OTHER") */}
          {bookingType === "other" && (
            <div className="passenger-details">
              <h3 style={{ marginTop: "15px" }}>Passenger Details</h3>

              <div className="input-row">
                <input
                  type="text"
                  placeholder="Passenger Full Name"
                  value={userDetails.passengerName}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only letters + space
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleInputChange("passengerName", value);
                    }
                  }}
                />
                {errors.passengerName && (
                  <p className="error">{errors.passengerName}</p>
                )}
                <input
                  type="text"
                  placeholder="Passenger Phone Number"
                  value={userDetails.passengerPhone}
                  onChange={(e) =>
                    handleInputChange("passengerPhone", e.target.value)
                  }
                />
                {errors.passengerPhone && (
                  <p className="error">{errors.passengerPhone}</p>
                )}
              </div>

              <div className="file-section">
                <p>Passenger Govt ID (For Verification)</p>
                <input
                  type="file"
                  onChange={(e) =>
                    handleFileChange("passengerId", e.target.files[0])
                  }
                />
                {errors.passengerId && (
                  <p className="error">{errors.passengerId}</p>
                )}
              </div>
            </div>
          )}

          {/* DATE TIME */}

          {/* PRICE */}
          <div className="price-box">
            <h2>Price Breakdown</h2>

            <div className="price-row">
              <span>Base Fare</span>
              <span>₹{baseFare}</span>
            </div>

            <div className="price-row discount">
              <span>Discount</span>
              <span>-₹{discount}</span>
            </div>

            <div className="price-row">
              <span>GST (18%)</span>
              <span>₹{gst}</span>
            </div>

            <div className="price-row security">
              <span>Security (Refundable)</span>
              <span>₹{security}</span>
            </div>

            <hr />

            <div className="total-row">
              <span>Total Payable</span>
              <span>₹{total}</span>
            </div>
          </div>
          <div className="payment-type-with-driver">
            <label>
              <input
                type="radio"
                value="full"
                checked={paymentType === "full"}
                onChange={() => setPaymentType("full")}
              />
              Full Payment
            </label>

            <label>
              <input
                type="radio"
                value="half"
                checked={paymentType === "half"}
                onChange={() => setPaymentType("half")}
              />
              Half Payment (remaining pay to the driver)
            </label>
          </div>
          <div className="payable-box">
            <h3>Pay Now: ₹{payableAmount}</h3>
          </div>
          {/* CHECKBOX */}
          <div className="checkbox">
            <input
              type="checkbox"
              checked={userDetails.agreed}
              onChange={(e) => handleInputChange("agreed", e.target.checked)}
            />
            {errors.agreed && <p className="error">{errors.agreed}</p>}
            <label>Send me ZikRme deals & updates.</label>
          </div>

          <p className="terms">
            By clicking "Book Now", you agree to our terms. This booking is
            managed directly by <b>ZikRme team</b>.
          </p>

          <button className="pay-btn" onClick={handlePayment}>
            CONTINUE TO PAYMENT
          </button>
        </div>
      </div>

      {showPolicy && (
        <div className="rental-modal-overlay">
          <div className="rental-modal">
            <span className="close" onClick={() => setShowPolicy(false)}>
              ✖
            </span>
            <h2>Rental Policy</h2>
            <ul>
              <li>Full refund if canceled 24h before.</li>
              <li>No smoking inside car</li>
              <li> Late return: ₹500/hour</li>
              <li>Fuel to be refilled to same level</li>
              <li>✔ Fuel included for 100km</li>
              <li>✔ 24/7 Roadside Assistance</li>
              <li>✖ Toll & Parking extra</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default TypeWithDriverDetailPage;
